import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";
import Credit from "./credit";
import { Locales } from "@/lib/i18n";
import { LinkField } from "@prismicio/client";
import { LinkHelper } from "@/components/atoms/link-helper";
import { __ } from "@/lib/i18n/functions";

type BentoProps = {
  variant: "lg" | "md" | "sm";
  image: {
    src: string;
    alt: string;
  };
  creditState: "default" | "open";
  photographer?: {
    name: string;
    avatar: string;
    description?: string;
  };
  button?: {
    text: string;
    link?: string | LinkField;
  };
  locale: Locales;
  link: string | LinkField;
  tag?: string;
  priority?: boolean;
  sizes?: string;
};

const defaultSizesByVariant: Record<BentoProps["variant"], string> = {
  lg: "(min-width: 1280px) 50vw, 100vw",
  md: "(min-width: 1280px) 50vw, 100vw",
  sm: "(min-width: 1280px) 25vw, (min-width: 768px) 50vw, 100vw",
};

const Bento = ({
  creditState,
  variant,
  image,
  photographer,
  button,
  locale,
  link,
  tag,
  priority = false,
  sizes,
}: BentoProps) => {
  return (
    <figure
      className={cn(
        "group/bento relative aspect-square h-full max-h-[280px] w-full cursor-pointer overflow-hidden rounded-lg sm:max-h-[485px] md:max-h-[39.375rem]",
        variant === "md" && "md:max-h-[18.75rem]",
        variant === "sm" && "md:max-h-80"
      )}
    >
      <Image
        alt={image.alt}
        src={image.src}
        fill
        sizes={sizes || defaultSizesByVariant[variant]}
        className="absolute object-cover transition-all duration-200 ease-in-out group-hover/bento:scale-[102%]"
        priority={priority}
      />
      <LinkHelper link={link} className="absolute inset-0">
        <span className="sr-only">{__("See inspiration", locale)}</span>
      </LinkHelper>
      <Credit
        state={creditState}
        name={photographer?.name}
        image={photographer?.avatar}
        description={photographer?.description}
        button={button}
        locale={locale}
        tag={tag}
        link={link}
        className="absolute top-4 left-4 z-10 w-fit"
      />
    </figure>
  );
};

export default Bento;
